import styled from 'styled-components';

import { breakpoints } from '@/shared/styles';

type Props = {
  className?: string;
  main?: boolean;
  children: React.ReactNode;
};

const StyledContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  gap: 3.2rem;
  max-width: 1136px;
  margin: 0 auto;
  padding: 4.8rem 1.6rem;
  width: 100%;
  justify-content: center;

  @media (min-width: ${breakpoints.tabletXL}px) {
    flex-direction: row;
  }
`;

const PageContainer: React.FC<Props> = ({ children, className, main }) => (
  <StyledContainer as={main ? 'main' : 'div'} className={className}>
    {children}
  </StyledContainer>
);

export { PageContainer };
